import { TextCodes } from '@api/types/translation/TextCodes';
import { PackageIcon } from '@components/common/Icons/PackageIcon';
import {
  Alert,
  Box,
  ClickAwayListener,
  Fade,
  IconButton,
  Paper,
  Popper,
  Stack,
} from '@mui/material';
import { colors } from '@themes/colors';
import { t } from '@translations';
import { useState } from 'react';

type ProductPackageChipProps = {
  showIcon?: boolean;
};

export const ProductPackageChip = ({ showIcon }: ProductPackageChipProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'package-popper' : undefined;
  return (
    <Alert
      variant='filled'
      severity='success'
      icon={false}
      sx={{
        p: 0,
        '& .MuiAlert-message': {
          padding: '4px',
        },
      }}
    >
      <Stack direction='row' gap={1} alignItems='center'>
        {showIcon && (
          <>
            <IconButton
              onClick={handleClick}
              aria-describedby={id}
              size='small'
              sx={{
                padding: '0',
                color: colors.text.primary,
                '&:focus': {
                  backgroundColor: open ? colors.primary.lightGreen : undefined,
                },
              }}
            >
              <PackageIcon
                height='16'
                width='16'
                fontSize='small'
                sx={{
                  display: { xs: 'block', md: 'none' },
                }}
              />
            </IconButton>
            <Popper
              id={id}
              open={open}
              anchorEl={anchorEl}
              transition
              sx={{
                zIndex: 1,
              }}
            >
              {({ TransitionProps }) => (
                <ClickAwayListener onClickAway={() => setAnchorEl(null)} touchEvent='onTouchStart'>
                  <Fade {...TransitionProps} timeout={350}>
                    <Paper sx={{ mt: 1 }}>
                      <Box sx={{ p: 1 }}>{t(TextCodes.Product.Details.PackageDeal)}</Box>
                    </Paper>
                  </Fade>
                </ClickAwayListener>
              )}
            </Popper>
          </>
        )}
        <Box
          sx={
            showIcon
              ? {
                  display: { xs: 'none', md: 'block' },
                }
              : {}
          }
        >
          {t(TextCodes.Product.Details.PackageDeal)}
        </Box>
      </Stack>
    </Alert>
  );
};
